import TrainingCategory from '../category';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingCategory.destroy(({ trainingId, categoryId }, fetch) => {
    return fetch.delete(`/trainings/${trainingId}/categories/${categoryId}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };